<template>
<right-panel :datas="connects" ref="rightPanel" @onClose="onCloseReport">
  <div slot="header">
    <translate>Generate Report</translate>
  </div>
  <div slot="content" class="wrapper-padding">
    report
  </div>
</right-panel>
</template>

<script>
//  import STORE_CONST from '../../../store/consts'
  import RightPanel from '../../common/right-panel'
  export default{
    name: 'LogReport',
    props: {
      items: {
        required: true
      }
    },
    data () {
      return {
        connects: null
      }
    },
    computed: {
      attrText () {
        return this.initTranslateText()
      }
    },
    methods: {
      // 提取翻译文本
      initTranslateText () {
        return {
          'resourceName': this.$gettext('Resource Name'),
          'command': this.$gettext('Command'),
          'member': this.$gettext('Member'),
          'resourceType': this.$gettext('Resource Type'),
          'time': this.$gettext('The Range Of Time'),
          'unlimited': this.$gettext('Unlimited'),
          'oneDay': this.$gettext('Within one day'),
          'oneMouth': this.$gettext('Within one mouth'),
          'sevenDay': this.$gettext('Within seven days')
        }
      },
      // 关闭侧滑
      onCloseReport () {
        this.connects = null
        this.$emit('onClosePanel')
      }
    },
    watch: {
      'items': {
        handler: function (newVal) {
          if (this.connects) {
            this.connects = null
            setTimeout(() => {
              this.connects = this.items
            }, 300)
          } else {
            this.connects = this.items
          }
        },
        deep: true
      }
    },
    components: {
      RightPanel
    }
  }
</script>

<style lang='scss' rel="stylesheet/scss">

</style>



// WEBPACK FOOTER //
// log-report.vue?60c3ce89